import { CoralException } from '@ch-types/CoralException';

export default class ServiceUnavailableException extends CoralException {}
